export const MODULE = 'DASHBOARD';
export const GET_YEAR_LIST = 'COLLECTION/GET_YEAR_LIST';

export const GET_COUNTS = `${MODULE}/get_count`;
export const GET_DATED_COUNTS = `${MODULE}/get_dated_count`;
export const GET_COLLECTION = `${MODULE}/get_collection`;

export const GET_COUNTS_SMART_CITY = `${MODULE}/get_count_smart_city`;

export const GET_ENEWS_COUNTS = `${MODULE}/get_enews_counts`

export const E_GOV = [
  'BPLS',
  'MVOPS',
  'CRIS',
  'SCMS',
  'MMS',
  'CDL',
  'PSA',
  'OHP',
  'RPTS',
  'BTAX',
];

export const COLORS = [
  '#A3B3F9',
  '#B1CDF8',
  '#BBE9FE',
  '#5272AA',
  '#84DAFF',
  '#8AA4F8',
  '#D9F5FA',
  '#8EEED7',
  '#7790CB',
  '#99BBFF',
];

export const STATISTICS = [
  { name: 'BPLS', color: '#5272AA', value: 0 },
  { name: 'BTAX', color: '#A3B3F9', value: 0 },
  { name: 'Cedula', color: '#8AA4F8', value: 0 },
  { name: 'Local Civil Registry', color: '#B1CDF8', value: 0 },
  { name: 'OVR', color: '#D9F5FA', value: 0 },
  { name: 'OHP', color: '#8EEED7', value: 0 },
  { name: 'RPTAX', color: '#240F7B', value: 0 },
];

export const E_GOV_COLORS = [
  { name: 'Business Process Licensing (BPLS)', color: '#A3B3F9' },
  { name: 'Cedula (CDL)', color: '#8AA4F8' },
  { name: 'Birth Certificates (PSA)', color: '#D9F5FA' },
  { name: 'Occupational and Health (OHP)', color: '#8EEED7' },
  { name: 'Real Property Tax (RPTAX)', color: '#7790CB' },
  { name: 'Business Tax (BTAX)', color: '#99BBFF' },
];

export const E_BILLS = [
  { name: 'SSS', color: '#A3B3F9', value: 0 },
  { name: 'PAG-IBIG', color: '#8AA4F8', value: 0 },
  { name: 'Philhealth', color: '#D9F5FA', value: 0 },
  { name: 'Private Billers', color: '#8EEED7', value: 0 },
];

export const E_COMMERCE = [
  { name: 'E-KITCHEN', color: '#A3B3F9', value: 0 },
  { name: 'E-MARKET', color: '#8AA4F8', value: 0 },
  { name: 'E-SHOPPING', color: '#D9F5FA', value: 0 },
  { name: 'E-DELIVERIES', color: '#8EEED7', value: 0 },
];

export const E_SERVICES = [
  { name: 'Amelioration', color: '#A3B3F9', value: 0 },
  { name: 'Job Hiring', color: '#8AA4F8', value: 0 },
  { name: 'Rentals', color: '#D9F5FA', value: 0 },
  { name: 'Loans', color: '#8EEED7', value: 0 },
];


export const E_NEWS = [
  { name: 'Non Video', color: '#A3B3F9', value: 0 },
  { name: 'Video', color: '#8AA4F8', value: 0 },
];

export const SERVICES_SELECT = [
  { label: 'E-GOVERNMENT', value: 'E-Government' },
  { label: 'E-BILLS PAYMENT', value: 'E-BILLS PAYMENT' },
  { label: 'E-COMMERCE', value: 'E-COMMERCE' },
  { label: 'E-SERVICE', value: 'E-SERVICE' },
];



// stats for  SMART-LGU (COLORS)
export const E_GOV_AND_SERVICES = [
  // note: 'value' keys are temporary only to display data while waiting for API update,
  // will update this code later once API is available.
  {
    RPTAX: [
      { name: 'Current', color: '#5272AA', value: 2},
      { name: 'Deliquent', color: '#A3B3F9', value: 3},
    ],
  },
  {
    BTAX: [
      { name: 'TAX_PAYMENT', color: '#5272AA', value: 3},
    ],
  },
  {
    E_BOSS: [
      { name: 'New', color: '#5272AA', value: 1},
      { name: 'Renewal', color: '#A3B3F9', value: 3},
      { name: 'Quarterly', color: '#8EEED7', value: 4},
      { name: 'Delinquent', color: '#87A1D1', value: 5},
    ],
  },
  {
    E_CEDULA: [
      { name: 'Individual', color: '#5272AA', value: 1},
      { name: 'Corporation', color: '#A3B3F9', value: 1},
    ],
  },
  {
    CIVIL_REGISTRY: [ // PSA
      { name: 'Birth Certificate', color: '#5272AA', value: 1},
    ],
  },
  {
    OHP: [
      // { name: 'Occupational and Health Permit', color: '#5272AA', value: 0},
      { name: 'New', color: '#5272AA', value: 2},
    ],
  },
  {
    OVR: [
      { name: 'Orinance Violation Receipt', color: '#5272AA', value: 3},
    ],
  }
]